import { AutoComplete, Button, Checkbox, Input, Modal, Select } from "antd";
import React, { useEffect, useRef, useState } from "react";
import TextArea from "antd/es/input/TextArea";
import { useMessage } from "../../Components/MessageProvider/MessageProvider";
import axiosInstance from "../../Components/axiosInstance/AxiosInstance";
import formatNumberWithSpaces from "../../Components/NumberToWords/FormatNumber";
import { OneCustomer } from "../../Stores/Customers/OneCustomer";
import { useNavigate, useParams } from "react-router-dom";

const searchResult = (query) => {
  return query.map((el, idx) => {
    return {
      value: `${el.id}. ${el.name}  INN:${el.INN}  TEL:${el.phone}`,
      label: (
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <span>{el.name}</span>
          <span>inn:{el.INN}</span>
          <span>{el.phone}</span>
        </div>
      ),
    };
  });
};

const { Option } = Select;

export default function KassaAdd({ isModalOpen, setIsModalOpen, getData }) {
  const { id } = useParams();
  const { fetchData } = OneCustomer();
  let [data, setData] = useState({
    from_customer_id: null,
    date: null,
    status: null,
    ykx_id: null,
    type: null,
    to_customer_id: null,
    sum: null,
    is_calculated: false,
    commet_calculated: null,
    given_by: null,
    dk: null,
    comment: null,
  });
  let [selected, setSelected] = useState(null);
  let [loading, setLoading] = useState(false);
  let [loadingCustomer, setLoadingCustomer] = useState(false);
  const messageApi = useMessage();

  const inputRefs = [
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
    useRef(null),
  ];

  const handleKeyDown = (e, index) => {
    if (e.key === "ArrowDown" || e.key === "ArrowUp") {
      // Prevent date value from changing
      if (e.target.type === "date") {
        e.preventDefault();
      }
      if (e.key === "ArrowDown") {
        // Focus the next input (if it exists)
        if (index < inputRefs.length - 1) {
          inputRefs[index + 1].current.focus();
        }
      } else if (e.key === "ArrowUp") {
        // Focus the previous input (if it exists)
        if (index > 0) {
          inputRefs[index - 1].current.focus();
        }
      }
    }
  };

  let uploadData = async () => {
    try {
      setLoading(true);

      let { data: info } = await axiosInstance.post("/api/kassa", {
        ...data,
      });
      if (info.success) {
        console.log("data");
        console.log(info);

        fetchData(id);
        setIsModalOpen(false);
      }
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  //   search customer
  const [options, setOptions] = useState([]);
  const [addOption, setAddOption] = useState("");

  const handleSearch = async (value) => {
    try {
      setLoadingCustomer(true);

      let { data } = await axiosInstance.get(
        "/api/customers/search?search=" + value
      );
      console.log(data);
      setSelected(data?.data);
      setOptions(value ? searchResult(data?.data) : []);
    } catch (error) {
      if (error?.response?.data?.error) {
        messageApi.open({
          type: "warning",
          content: error?.response?.data?.message,
        });
      } else {
        messageApi.open({
          type: "warning",
          content: error.message,
        });
      }
    } finally {
      setLoadingCustomer(false);
    }
  };

  const onSelect_to = (value) => {
    setSelected(value);

    console.log(value.split(".")[0]);
    console.log(value);
    setData({
      ...data,
      to_customer_id: Number(value.split(".")[0]),
    });
  };

  const onSelect_from = (value) => {
    setSelected(value);

    console.log(value.split(".")[0]);
    console.log(value);
    setData({
      ...data,
      from_customer_id: Number(value.split(".")[0]),
    });
  };

  const onSelect_given_by = (value) => {
    setSelected(value);

    console.log(value.split(".")[0]);
    console.log(value);
    setData({
      ...data,
      given_by: Number(value.split(".")[0]),
    });
  };
  return (
    <Modal
      style={{ top: "10px" }}
      title="Mahsulot qo'shish"
      open={isModalOpen}
      //   loading={loadVagon}
      onOk={() => {
        setIsModalOpen(false);
      }}
      onCancel={() => {
        console.log("Modal closed via Cancel button or close icon.");
        setIsModalOpen(false);
      }}
      footer={[
        <Button
          key="back"
          onClick={() => {
            setIsModalOpen(false);
          }}
          style={{ backgroundColor: "#f5222d", color: "#fff" }}
        >
          Tozalash
        </Button>,
        <Button
          key="submit"
          type="primary"
          onClick={() => {
            console.log(data);
            uploadData();
          }}
        >
          Saqlash
        </Button>,
      ]}
    >
      {/* <p className="text-[14px] text-[#111827] p-0 m-0 col-span-2">yozdi</p> */}
      <div>
        <div className="w-[100%]">
          <label className="text-[16px] block ">Kimdan </label>
          <AutoComplete
            popupMatchSelectWidth={"100px"}
            style={{
              width: "100%",
            }}
            className="max-w-[900px]"
            options={options}
            onSelect={onSelect_from}
            onSearch={handleSearch}
            size="medium"
          >
            <Input.Search
              loading={loadingCustomer}
              size="medium"
              placeholder="Qidirish..."
              ref={inputRefs[0]}
              enterButton
            />
          </AutoComplete>
        </div>

        <label className="text-[16px] "> Sana</label>
        <Input
          type="date"
          placeholder="time"
          value={data?.date}
          ref={inputRefs[1]}
          onKeyDown={(e) => {
            handleKeyDown(e, 0);
            if (e.key === "F2") {
              const currentDate = new Date().toISOString().split("T")[0]; // Get current date in YYYY-MM-DD format
              setData({
                ...data,
                date: currentDate,
              });
            }
          }}
          onChange={(e) => {
            setData({
              ...data,
              date: e.target.value,
            });
          }}
        />

        <label className="text-[14px] block mt-2 ">Naqt / Prechislena</label>
        <select
          className="w-[100%] border-[1px] border-[#bfbfbf] rounded  hover:border-[blue] hover:cursor-pointer px-2 py-1 text-[14px] focus:boder-[blue] focus:boder-[1px]"
          ref={inputRefs[2]}
          placeholder="Select an option"
          selected={data?.type}
          onChange={(e) => {
            setData({
              ...data,
              type: e.target.value,
            });
          }}
        >
          <option value="" className="w-[100%] block">
            Tanlash
          </option>
          <option value="prechislena" className="w-[100%] block">
            prechislena
          </option>
          <option value="naqt">naqt</option>
          {/* <option value="option3">Option 3</option> */}
        </select>
        <div className="w-[100%]">
          <label className="text-[16px] block ">Kimga </label>
          <AutoComplete
            popupMatchSelectWidth={"100px"}
            style={{
              width: "100%",
            }}
            className="max-w-[900px]"
            options={options}
            onSelect={onSelect_to}
            onSearch={handleSearch}
            size="medium"
          >
            <Input.Search
              ref={inputRefs[3]}
              loading={loadingCustomer}
              size="medium"
              placeholder="Qidirish..."
              enterButton
            />
          </AutoComplete>
        </div>

        <label className="text-[16px] ">
          Summa {formatNumberWithSpaces(data.sum ? data.sum : 0)}
        </label>
        <Input
          type="text"
          placeholder="Summani kiriting"
          autoFocus={true}
          value={data.sum}
          ref={inputRefs[4]}
          onKeyDown={(e) => {
            handleKeyDown(e, 1);
          }}
          onChange={(e) => {
            setData({
              ...data,
              sum: e.target.value,
            });
          }}
        />
        <div className="my-2">
          <Checkbox
            onChange={(e) => {
              // console.log(e);
              setData({
                ...data,
                is_calculated: e.target.checked,
              });
            }}
          >
            <p className="text-[16px] m-0 p-0">Kassada xissoblanmasinmi ?</p>
          </Checkbox>
        </div>
        <div className="w-[100%]">
          <label className="text-[16px] block ">
            Berib yuboruvchi -- (Kafil){" "}
          </label>
          <AutoComplete
            popupMatchSelectWidth={"100px"}
            style={{
              width: "100%",
            }}
            className="max-w-[900px]"
            options={options}
            onSelect={onSelect_given_by}
            onSearch={handleSearch}
            size="medium"
          >
            <Input.Search
              ref={inputRefs[3]}
              loading={loadingCustomer}
              size="medium"
              placeholder="Qidirish..."
              enterButton
            />
          </AutoComplete>
        </div>
        <label className="text-[16px] ">Izoh</label>
        <TextArea
          rows={4}
          placeholder="Type your text here..."
          value={data.comment}
          ref={inputRefs[13]}
          onKeyDown={(e) => {
            handleKeyDown(e, 13);
          }}
          onChange={(e) => {
            setData({
              ...data,
              comment: e.target.value,
            });
          }}
        />
      </div>
    </Modal>
  );
}
